// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import PropTypes from "prop-types";
import MuiStep from "@mui/material/Step";

export function Step({ label, optional, children }: any) {
  return (
    <MuiStep label={label} optional={optional}>
      {children}
    </MuiStep>
  );
}

Step.propTypes = {
  label: PropTypes.string,
  optional: PropTypes.bool,
  children: PropTypes.node,
};
